import React, { useRef, useState } from 'react'
import { useOutsideClickHandler } from '../../utils/browser';
import { PRIMARY_DARK } from '../../constants/constants';
const FloatyMenu = ({
  menuIsOpen,
  onClose,
  left,
  top,
  options,
  onItemClick
}) => {
  const ref = useRef();
  const [hoveredIdx, setHoveredIdx] = useState()
  useOutsideClickHandler(ref, () => {
    if (menuIsOpen) {
      if (onClose)
        onClose()
      setHoveredIdx()
    }
  });

  if (!menuIsOpen) return null;

  return (
    <div
      ref={ref}
      style={{
        position: 'fixed',
        zIndex: 99999,
        left,
        top,
        minWidth: 180,
        padding: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: '#f5f5f7',
        border: '1px solid #d9d9d9',
        borderRadius: 8,
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12)',
      }}
    >
      {
        options.map(({ label, id }, idx) =>
          <div key={id}
            onMouseOver={() => setHoveredIdx(idx)}
            onMouseLeave={() => setHoveredIdx()}
            onClick={(e) => onItemClick && onItemClick(e, { label, id })}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              cursor: 'pointer',
              color: PRIMARY_DARK,
              backgroundColor: hoveredIdx === idx ? '#ffffff' : 'transparent',
              boxShadow: hoveredIdx === idx ? '0 1px 2px rgba(0, 0, 0, 0.08)' : undefined,
              transition: 'background-color 0.15s',
            }}>
            {label}
          </div>
        )
      }
    </div>
  )
}

export default FloatyMenu
